import type { VfConfig } from '#types/config/components/vf'

export default {
  brandClasses: {
    base: 'subtitle-5 rounded-xs px-4 py-2 i-flex duration peer-focus-visible:outline-auto',
    selected: 'bg-brand-1 c-white peer-focus-visible:outline-offset-2',
    unselected: 'bg-brand-2'
  }
} satisfies VfConfig['toggleToken']
